import { useQuery } from '@tanstack/react-query'
import { query } from 'config/api'
import { useMemo } from 'react'

export function useGradeExplanationReadiness(enabled: boolean): Set<string> {
  const readinessResult = useQuery({
    ...query.api.v1.users.me.gradeExplanationReadiness.index.queryOptions(),
    enabled,
    staleTime: 30_000,
  })

  return useMemo(() => {
    const readyAssignments = new Set<string>()
    if (readinessResult.data && !('error' in readinessResult.data)) {
      for (const result of readinessResult.data) {
        if (result.ready) {
          readyAssignments.add(`${result.assignmentId}/${result.roomId}`)
        }
      }
    }
    return readyAssignments
  }, [readinessResult.data])
}
